import { createAction, props } from '@ngrx/store'
import { EVisitorResponse, EVisitorCheckinPayload } from './evisitor.model'

// Check-in to eVisitor
export const CheckInToEVisitor = createAction(
  '[EVisitor] Check In',
  props<{ bookingId: string; payload: EVisitorCheckinPayload; gatewayId: string; guestPkey: string }>()
)

export const CheckInToEVisitorSuccess = createAction(
  '[EVisitor] Check In Success',
  props<{ bookingId: string; response: EVisitorResponse; guestPkey: string }>()
)

export const CheckInToEVisitorFailure = createAction(
  '[EVisitor] Check In Failure',
  props<{ bookingId: string; error: any; guestPkey: string }>()
)

// Check-out from eVisitor
export const CheckOutFromEVisitor = createAction(
  '[EVisitor] Check Out',
  props<{ bookingId: string; referenceId: string; gatewayId: string; departure: number; guestPkey: string }>()
)

export const CheckOutFromEVisitorSuccess = createAction(
  '[EVisitor] Check Out Success',
  props<{ bookingId: string; response: EVisitorResponse; guestPkey: string }>()
)

export const CheckOutFromEVisitorFailure = createAction(
  '[EVisitor] Check Out Failure',
  props<{ bookingId: string; error: any; guestPkey: string }>()
)

// Cancel eVisitor Registration
export const CancelEVisitorRegistration = createAction(
  '[EVisitor] Cancel eVisitor Registration',
  props<{ bookingId: string; referenceId: string; gatewayId: string; guestPkey: string }>()
)

export const CancelEVisitorRegistrationSuccess = createAction(
  '[EVisitor] Cancel eVisitor Registration Success',
  props<{ bookingId: string; response: EVisitorResponse; guestPkey: string }>()
)

export const CancelEVisitorRegistrationFailure = createAction(
  '[EVisitor] Cancel eVisitor Registration Failure',
  props<{ bookingId: string; error: any; guestPkey: string }>()
)

// Clear state for a booking (when overlay closes)
export const ClearEVisitorState = createAction('[EVisitor] Clear eVisitor State', props<{ bookingId: string }>())
